import { ChangeDetectionStrategy, Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { ButtonComponent, IconButtonComponent } from '@libs/common/components';
import { ShoppingListModel } from '@libs/shop/models';
import { ConfirmationDialogModule, ConfirmationDialogService, ShoppingListsState } from '@libs/shared/services';
import { LinkDirective } from '@libs/shared/ui';
import { from, of, switchMap } from 'rxjs';

@Component({
  selector: 'ui-shopping-list-actions',
  templateUrl: './shopping-list-actions.component.html',
  styleUrls: ['./shopping-list-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IconButtonComponent,
    ButtonComponent,
    LinkDirective,
    ConfirmationDialogModule,
  ],
})
export class ShoppingListActionsComponent {
  public shoppingListsState: ShoppingListsState = inject(ShoppingListsState);
  public shoppingList: InputSignal<ShoppingListModel> = input.required();
  public shoppingListUrl: Signal<string> = computed(() => `shopping-lists/${this.shoppingList().id}`);

  private readonly confirmationDialog: ConfirmationDialogService = inject(ConfirmationDialogService);

  public deleteClicked(): void {
    this.confirmationDialog.open({
      title: 'Einkaufsliste wirklich löschen?',
      confirm: 'Ja',
      decline: 'Nein',
    }).pipe(
      switchMap(result => result ? from(this.shoppingListsState.deleteShoppingList(this.shoppingList().id)) : of(undefined)),
    ).subscribe();
  }
}
